import { setAudioSidecarFlag } from '@src/utility/audioSidecarFlag';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useEffect } from 'react';

/**
 * Mirrors the `story-upload-audio-sidecar` LaunchDarkly flag into the
 * module-level switch the Add Story flow reads (it decides at file-select,
 * outside React's render). Mount once at the app root, under the LD provider,
 * next to `useAudioThenVideoFlagSync`.
 */
export function useAudioSidecarFlagSync(): void {
  const { storyUploadAudioSidecar } = useFlags();
  useEffect(() => {
    setAudioSidecarFlag(storyUploadAudioSidecar);
  }, [storyUploadAudioSidecar]);
}
